<template>
  <div class="stockApp">
    <div class="stock">
      <Header></Header>
      <main>
        <div class="mainBottom">
          <!-- 左侧菜单栏 -->
          <div class="pharmaLeft_Box">
            <LeftNav v-show="collapse" :navData="navData" :leftCurrentNode="leftCurrentNode"></LeftNav>
            <div class="title-img" @click="collapseChage">
              <img v-if="collapse" src="../../assets/img/sq.png" alt />
              <img v-else src="../../assets/img/zk.png" alt style="margin:0" />
              <!-- <i v-if="collapse" class="el-icon-d-arrow-left"></i> -->
              <!-- <i v-else class="el-icon-d-arrow-right"></i> -->
            </div>
          </div>
          <!-- 右侧内容 -->
          <router-view :collapse="collapse"></router-view>
        </div>
      </main>
      <Footer></Footer>
    
    </div>
  </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import LeftNav from "@/components/leftNav";
import api from "@/../static/common/api/api.js";

export default {
  props: {},
  components: {
    Header,
    Footer,
    LeftNav
  },
  data() {
    return {
      collapse: true, //隐藏导航
      leftCurrentNode: 3, //导航默认选中
      navData: [
        {
          id: 0,
          label: "上市企业",
          path: "/enterprises"
        },
        // {
        //   id: 1,
        //   path: "/",
        //   label: "用工招聘"
        // },
        {
          id: 2,
          path: "/tendering",
          label: "政府采购"
        },
        {
          id: 3,
          path: "/judgement",
          label: "裁判文书"
        }
      ]
    };
  },
  computed: {},
  methods: {
    collapseChage() {
      this.collapse = !this.collapse;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style scoped lang="less">
@import "../../assets/less/tableScrollbar.less";

.stockApp {
  background: url("../../assets/img/bg.png") no-repeat top;
  display: flex;
}
.stock {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
main {
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .mainTop {
    display: flex;
    .underHeader {
      display: inline-block;
      height: 54px;
      line-height: 54px;
      padding-left: 19px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
      img {
        width: 12px;
        height: 16px;
      }
    }
    /deep/ .el-breadcrumb__inner {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
    }
  }
  .mainBottom {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
  }
}
.pharmaLeft_Box {
  display: flex;
}
.title-img {
  img {
    width: 16px;
    height: 54px;
    margin: auto;
    margin-right: 23px;
    margin-left: -16px;
    z-index: 99;
    position: relative;
    // top:50%;
  }
}
</style>
 


// WEBPACK FOOTER //
// src/view/judgement/index.vue